import { useCallback, useMemo } from 'react';
import { ReactComponent as RecommendIcon } from 'public/assets/icons/recommend.svg';
import { PlaningViewsEnum } from '@/components/common/PlanYourTrip/constants';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { useAnalytics } from '@/tracking/analytics';
import { Button } from '@/components/ui/button';
import { ContextKey } from '@/components/common/PlanYourTrip/types';

import { patnerTypes } from './partnerTypes';

const partnerLayoutClass = [
  'flex m-[22px] pt-[30px] border border-primary rounded-lg',
  '[&_svg]:h-auto',
  'max-sm:flex-col',
].join(' ');

const iconBlockClass = [
  'px-5',
  'max-sm:text-center',
].join(' ');

const partnerInfoBlockClass = [
  'text-sm',
  '[&_h3]:text-[20px] [&_h3]:leading-[30px]',
  'max-sm:flex max-sm:flex-col max-sm:justify-center max-sm:px-5',
].join(' ');

const recommendClass = [
  'mb-[15px] text-[12px]',
  '[&>span]:ml-2.5',
].join(' ');

const searchButtonClass = 'mb-[25px] h-auto px-[27px] py-[15px] font-bold';

interface IPartnerBlockProps {
  partnerLinkUrl?: string
  partnerType: PlaningViewsEnum.rental | PlaningViewsEnum.lessons
  title: string,
  country?: string
  /**
   * resort ore region, used for appropriate translation,
   */
  contextKey: ContextKey,
}

const PartnerBlock = ({
  partnerLinkUrl,
  partnerType,
  title,
  contextKey = 'resort',
}: IPartnerBlockProps) => {
  const { t } = useOTSTranslation('common');
  const analitics = useAnalytics();

  const { icon, header, analiticType } = useMemo(() => patnerTypes[partnerType], [partnerType]);
  const benefits = patnerTypes[partnerType].benefits as Array<I18nKeyGenerated['common']>;

  const onSearchClick = useCallback(() => {
    analitics.subcriberEvent(analiticType, { url: partnerLinkUrl });

    window.open(partnerLinkUrl, '_blank');
  }, [analitics, partnerLinkUrl]);

  return (
    <div className={partnerLayoutClass}>
      <div className={iconBlockClass}>{icon}</div>
      <div className={partnerInfoBlockClass}>
        <div className={recommendClass}>
          <RecommendIcon />
          <span>{t('tripWidget.partnerLabel', { [contextKey]: title })}</span>
        </div>
        <h3>{t(header as I18nKeyGenerated['common'], { [contextKey]: title })}</h3>
        <ul>{benefits.map((i) => <li key={i}>{t(i)}</li>)}</ul>
        <Button className={searchButtonClass} onClick={onSearchClick}>
          {t('tripWidget.searchOffers')}
        </Button>
      </div>
    </div>
  );
};

export default PartnerBlock;
